import { customFetch, appendHeadersWithJSONContentType } from 'utils/http';
import {
  HTTPResponseError,
  EmailAlreadyInUseError,
  CaptchaError,
} from 'utils/errors';
import { m8ErrorMessageMap } from 'services/production/utils/constants';
import { M8UserProfile, M8AccountInfo } from 'services/production/types';
import { TSex } from 'types/state';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  userProfile: Partial<M8UserProfile>;
  email: string;
  sex: TSex;
  recaptchaToken: string;
};

export const register = async (params: Params): Promise<M8AccountInfo> => {
  const { userProfile, email, sex, recaptchaToken } = params;

  const body = JSON.stringify({
    ...userProfile,
    recaptchaToken,
    email,
    sex,
  });

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(getM8AuthURL('registerUser'), {
    method: 'POST',
    body,
    headers,
  });

  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();
      if (data.message === m8ErrorMessageMap.EMAIL_ALREADY_IN_USE) {
        throw new EmailAlreadyInUseError();
      }
      if (data.message === m8ErrorMessageMap.CAPTCHA_EXCEPTON) {
        throw new CaptchaError();
      }
    }
    throw new HTTPResponseError(response);
  }

  return response.json();
};
